import * as React from 'react';

import classnames from 'classnames';

import {FileAudioIcon} from '../../../icon/svg/file-audio-icon';

import {AddReactionButton} from '../../reaction-bar/add-reaction-button';
import {ReactionBar} from '../../reaction-bar/reaction-bar';
import type {Reaction, Reactions} from '../../reaction-bar/types';

import {EmailEngagement} from './email-engagement';
import type {Props as EmailEngagementProps} from './email-engagement';
import {ThreadData} from './thread-data';
import type {Props as ThreadDataProps} from './thread-data';

import styles from './timeline-entry-footer.module.css';

// EmailEngagementReactionBarProps
export type Props = {
    // Email engagement props
    emailEngagement?: EmailEngagementProps;
    disableReactions?: boolean;
    threadData?: ThreadDataProps;
    hasActivityTranscription?: boolean;
};

type OwnProps = Props & {
    reactions?: Reactions;
    alwaysShowAddButton?: boolean;
    currentUserId?: string;
    onToggleReaction?: (reaction: Reaction) => any;
};

export function TimelineEntryFooter(props: OwnProps) {
    const {
        emailEngagement: emailEngagementProps,
        threadData: threadDataProps,
        alwaysShowAddButton,
        disableReactions,
        currentUserId,
        onToggleReaction,
        reactions,
        hasActivityTranscription,
    } = props;

    const hasEmailEngagement = Boolean(
        emailEngagementProps &&
            (emailEngagementProps.attachments.length ||
                emailEngagementProps.opens ||
                emailEngagementProps.clicks)
    );
    const hasThreadData = Boolean(
        threadDataProps && (threadDataProps.messageCount || threadDataProps.replyCount)
    );

    const hasReactions = Boolean(reactions && Object.keys(reactions).length);
    const canRenderReactionBar = Boolean(
        !disableReactions && hasReactions && onToggleReaction && currentUserId
    );

    return hasEmailEngagement ||
        hasReactions ||
        hasThreadData ||
        hasActivityTranscription ||
        alwaysShowAddButton ? (
        <div
            className={classnames(
                `flex ${
                    hasEmailEngagement || hasThreadData || hasActivityTranscription
                        ? 'justify-sb'
                        : 'justify-end'
                }`,
                styles['timeline-footer-bar']
            )}
        >
            {hasEmailEngagement ? (
                <div className={styles['left-container']}>
                    {/* @ts-expect-error */}
                    <EmailEngagement {...emailEngagementProps} />
                </div>
            ) : undefined}
            {/* @ts-expect-error */}
            {hasThreadData ? <ThreadData {...threadDataProps} /> : undefined}
            {hasActivityTranscription && <FileAudioIcon size={17} />}
            {canRenderReactionBar && reactions && currentUserId && onToggleReaction ? (
                <ReactionBar
                    reactions={reactions}
                    currentUserId={currentUserId}
                    onToggleReaction={onToggleReaction}
                />
            ) : undefined}
            {alwaysShowAddButton && !hasReactions && onToggleReaction ? (
                <AddReactionButton onSelectReaction={onToggleReaction} />
            ) : undefined}
        </div>
    ) : null;
}
